/*
 * SDK连接相关
 */

import config from '@/config/nimConfig'
// import pageUtil from '@/utils/page'
import { get_tUser } from '@/assets/js/utils'
import store from '@/store'
// import {onFriends, onSyncFriendAction} from './friends'
// import {onRobots} from './robots'
// import {onBlacklist, onMarkInBlacklist} from './blacks'
// import {onMyInfo, onUserInfo} from './userInfo'
// import {onSessions, onUpdateSession} from './session'
// import {onRoamingMsgs, onOfflineMsgs, onMsg} from './msgs'
// import {onSysMsgs, onSysMsg, onSysMsgUnread, onCustomSysMsgs} from './sysMsgs'
// import { onTeams, onSynCreateTeam, onCreateTeam, onUpdateTeam, onTeamMembers, onUpdateTeamMember, onAddTeamMembers, onRemoveTeamMembers, onUpdateTeamManagers, onDismissTeam, onUpdateTeamMembersMute, onTeamMsgReceipt} from './team'

// 文档地址：https://dev.yunxin.163.com/docs/product/IM即时通讯/SDK开发集成/Web开发集成/初始化#参数解释

let SDK = require('@/assets/js/plugins/nim-sdk/' + config.sdk)
// 所有接口
import Actions from '@/api/api-list';

// 重新初始化 NIM SDK
export function initNimSDK ({ state, commit, dispatch }, loginInfo) {
  if(!SDK){
    return
  }
  if (state.nim) {
    state.nim.disconnect()
  }
  // dispatch('showLoading')
  // console.log(state)
  // 初始化SDK
  let nimInstance = SDK.NIM.getInstance({
    debug: false,
    appKey: config.appkey,
    account: loginInfo.uid, // cv account token 或者 hr account token
    token: loginInfo.sdktoken, // 根据后端接口，拿到网易token
    transports: ['websocket'],
    // db: config.useDb, //是否开启本地数据库
    // logFunc: new SDK.NIM.LoggerPlugin({
    //   url: '/webdemo/h5/getlogger',
    //   level: 'info'
    // }),
    syncSessionUnread: true,
    syncRobots: true,
    autoMarkRead: true, // 默认为true

    // 连接建立后的回调(登录成功)
    onconnect: (event) => {
      // console.log('onconnect', loginInfo)
      // // 清除网络异常
      commit('updateNetworkAnomaly', false)

      if (loginInfo) {
        // 连接上以后更新uid
        commit('updateUserUID', loginInfo)
        // 同步im连接状态
        commit('setImConnectionState', true)
      }
    },
    // 即将重连的回调
    onwillreconnect: function onWillReconnect (event) {
      // console.log('onwillreconnect=>>>>',event)
      // 是否网络异常
      commit('updateNetworkAnomaly', true)
    },
    //断开连接后的回调
    ondisconnect: function onDisconnect (error) {
      if(error){
        let c_t = get_tUser().c_t;

        let sdkTokenObj = localStorage.getItem('sdkTokenObj');
        sdkTokenObj = sdkTokenObj ? JSON.parse(sdkTokenObj) : {};
        if(c_t){
          Actions.im.getNimToken(c_t).then(res=>{
            if(res.code === 1000){
              sdkTokenObj[c_t] = res.data.acc_token;
              localStorage.setItem('sdkTokenObj', JSON.stringify(sdkTokenObj));
              // 提交sdk连接请求
              store.dispatch('nim/connect')
              // store.dispatch('nim/updateRefreshState')
            }
          })
        }
      }
      console.log('ondisconnect=>>>>',error)
      // switch (error.code) {
      //   // 账号或者密码错误, 请跳转到登录页面并提示错误
      //   case 302:
      //     pageUtil.turnPage('帐号或密码错误', 'login')
      //     break
      //   // 被踢, 请提示错误后跳转到登录页面
      //   case 'kicked':
      //     let map = {
      //       PC: '电脑版',
      //       Web: '网页版',
      //       Android: '手机版',
      //       iOS: '手机版',
      //       WindowsPhone: '手机版'
      //     }
      //     let str = error.from
      //     let errorMsg = `你的帐号于${util.formatDate(new Date())}被${(map[str] || '其他端')}踢出下线，请确定帐号信息安全!`
      //     pageUtil.turnPage(errorMsg, 'login')
      //     break
      //   default:
      //     break
      // }
    },
    // 发生错误的回调
    onerror: function onError (event) {
      console.log('onerror', event)
      // 是否网络异常
      commit('updateNetworkAnomaly', true)
      // alert(JSON.stringify(event))
      // debugger
      // _myself.$message.error('网络连接状态异常')
      // location.href = config.loginUrl
    },
    /*
    // 多端登录
    // onloginportschange: onLoginPortsChange,
    // 用户关系及好友关系
    onblacklist: onBlacklist, //黑名单
    onsyncmarkinblacklist: onMarkInBlacklist,
    // onmutelist: onMutelist, //静音列表
    // onsyncmarkinmutelist: onMarkInMutelist, //加入/移除静音列表
    onfriends: onFriends, //好友
    onsyncfriendaction: onSyncFriendAction, //多端同步好友操作/添加，拉黑，静音等
    // 机器人
    onrobots: onRobots,
    // 用户名片 - actions/userInfo
    onmyinfo: onMyInfo, //我的名片
    onupdatemyinfo: onMyInfo,
    onusers: onUserInfo, //好友的名片
    onupdateuser: onUserInfo,
    // // 群组
    onteams: onTeams, //群
    onsynccreateteam: onSynCreateTeam,
    syncTeams: true,
    onteammembers: onTeamMembers,
    onCreateTeam: onCreateTeam,
    onDismissTeam: onDismissTeam,
    onUpdateTeam: onUpdateTeam,
    onAddTeamMembers: onAddTeamMembers,
    onRemoveTeamMembers: onRemoveTeamMembers,
    onUpdateTeamManagers: onUpdateTeamManagers,
    onupdateteammember: onUpdateTeamMember,
    onUpdateTeamMembersMute: onUpdateTeamMembersMute,
    onTeamMsgReceipt: onTeamMsgReceipt,
    // 会话
    // 收到会话列表
    onsessions: onSessions,
    // 会话更新了
    onupdatesession: onUpdateSession,
    // 消息
    onroamingmsgs: onRoamingMsgs, // 漫游消息
    onofflinemsgs: onOfflineMsgs, // 离线消息
    onmsg: onMsg,
    // // 系统通知
    onsysmsg: onSysMsg,
    onofflinesysmsgs: onSysMsgs,
    onupdatesysmsg: onSysMsg, // 通过、拒绝好友申请会收到此回调

    onsysmsgunread: onSysMsgUnread,
    onupdatesysmsgunread: onSysMsgUnread,

    onofflinecustomsysmsgs: onCustomSysMsgs,
    oncustomsysmsg: onCustomSysMsgs,
    // // 同步完成
    onsyncdone: function onSyncDone () {
      dispatch('hideLoading')
      // 说明在聊天列表页
      if (store.state.currSessionId) {
        dispatch('setCurrSession', store.state.currSessionId)
      }
    },
    
    syncStickTopSessions: true, //开启曝光提示
    // onStickTopSessions: (list)=>{ //曝光设置/获取回调
    //   console.log('onStickTopSessions',list)
    //   let OutOfDateTime = new Date().getTime() - 30*24*60*60*1000 // 30天前的时间戳
    //   // let OutOfDateTime = new Date().getTime() - 60*1000 // 30天前的时间戳
    //   list = list.filter(item => item.updateTime >= OutOfDateTime)
    //   store.dispatch('im/getStickTopUserList', list)
    // }
    */
  })
  // window.nim.useDb = config.useDb

  // commit('setNimInstance', nimInstance)
  if(window){
    window.nim = nimInstance
    // window.nim.useDb = config.useDb
  }
}
